import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'

export interface gameDetailsState {
  gameId: string
  coverImage: string
  gameStatus: string
  gameVisibility: 'public' | 'unlisted'
  publishStatus: boolean
}

const initialState: gameDetailsState = {
  gameId: '',
  coverImage: '',
  gameStatus: '',
  gameVisibility: 'public',
  publishStatus: false,
}

export const gameDetailsSlice = createSlice({
  name: 'gameDetails',
  initialState,
  reducers: {
    setGameId: (state, action: PayloadAction<string>) => {
      state.gameId = action.payload
    },
    setCoverImage: (state, action: PayloadAction<string>) => {
      state.coverImage = action.payload
    },
    setGameStatus: (state, action: PayloadAction<string>) => {
      state.gameStatus = action.payload
    },
    setGamePublishStatus: (state, action: PayloadAction<boolean>) => {
      state.publishStatus = action.payload
    },
    setGameVisibility: (
      state,
      action: PayloadAction<'public' | 'unlisted'>
    ) => {
      state.gameVisibility = action.payload
    },
    clearGameDetails: () => {
      return { ...initialState }
    },
  },
})

export const {
  setGameId,
  setCoverImage,
  setGameStatus,
  setGamePublishStatus,
  setGameVisibility,
  clearGameDetails,
} = gameDetailsSlice.actions

export default gameDetailsSlice.reducer
